import { EnvironmentProviders, Provider, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { REALTIME_CONFIG, REALTIME_TOKEN_PROVIDER, RealtimeConfig, RealtimeTokenProvider } from './realtime.config';
import { RealtimeConnection } from './realtime-connection';

/**
 * Wires the realtime layer into an application. This is the only line the host has to add.
 *
 * The connection is opened by an app initializer only when a token already exists — i.e. on a
 * reload of an authenticated session. A fresh login has no token at bootstrap, so the host
 * calls `RealtimeConnection.start()` after signing in. The connection follows the session, not
 * the application lifecycle.
 */
export function provideRealtime(config: RealtimeConfig, tokenProvider: Provider): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: REALTIME_CONFIG, useValue: config },
    tokenProvider,
    provideAppInitializer(() => {
      const connection = inject(RealtimeConnection);
      const tokens = inject<RealtimeTokenProvider>(REALTIME_TOKEN_PROVIDER);

      if (config.enabled && tokens.getToken()) {
        // Never awaited: a realtime connection is not allowed to delay application bootstrap.
        void connection.start();
      }
    })
  ]);
}
